/* Minari Theme — JS */

/* ── Transparent header: add .scrolled when user scrolls past hero ── */
(function () {
  var header = document.getElementById('site-header');
  if (!header) return;

  function onScroll() {
    if (window.scrollY > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load in case page is already scrolled
})();

/* ── Product page image thumbnails ── */
(function () {
  var thumbs = document.querySelectorAll('.thumb');
  var mainImg = document.querySelector('.product-img-main img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = this.dataset.src;
      if (src) {
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });
})();

/* ── Cart quantity controls ── */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;

    var action = btn.dataset.qty;
    var key = btn.dataset.key;
    var display = btn.closest('.qty-control')?.querySelector('span');
    if (!display) return;

    var current = parseInt(display.textContent, 10) || 1;
    var next = action === 'plus' ? current + 1 : Math.max(1, current - 1);
    if (next === current) return;

    display.textContent = next;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.cart-badge');
        if (badge) badge.textContent = cart.item_count;
      })
      .catch(function (err) { console.warn('Cart update failed', err); });
  });
})();
